<template>
  <div class="usrBox">
    <div class="header">
      <van-row class="info">
        <van-col span='4' offset='1'>
          <van-image v-if ="$store.state.accessToken && $store.state.accessToken.headImgUrl" round width="55px" height="55px" :src="$store.state.accessToken.headImgUrl"/>
          <van-image v-else round width="55px" height="55px" :src="require('../../../assets/user.png')"/>
        </van-col>
        <van-col span='12' offset='2' style="margin-top:15px">{{ topUsername }}</van-col>
        <van-col span='4'><van-icon name="diamond-o" style="margin-top:20px;float:right"> {{ rank }}</van-icon></van-col>
      </van-row>
      <van-row class="degree">
        <van-col span='20' offset='1'><van-progress color="#fff" track-color="#3388ff" :percentage="percentageNum" /></van-col>
        <van-col span='2' offset='1' style="margin-top:-7px">{{ ranks }}</van-col>
      </van-row>
      <van-row class="item">
        <van-col span='6'>我的卡(张)<br>
          <span style="font-size:14px">{{ topForm.cardQuantity ? topForm.cardQuantity : '0' }}</span>
        </van-col>
        <van-col span='6'>余额(元)<br>
          <span style="font-size:14px">{{ topForm.balance ? topForm.balance : '0' }}</span>
        </van-col>
        <van-col span='6'>当日分润(元)<br>
          <span style="font-size:14px">{{ topForm.todayProfit ? topForm.todayProfit : '0' }}</span>
        </van-col>
        <van-col span='6'>当月分润(元)<br>
          <span style="font-size:14px">{{ topForm.thisMonthProfit ? topForm.thisMonthProfit : '0' }}</span>
        </van-col>
      </van-row>
      <!-- <div class="contentHeader">
        <div class="top title">
          <van-image v-if ="$store.state.accessToken && $store.state.accessToken.headImgUrl" round width="55px" height="55px" :src="$store.state.accessToken.headImgUrl"/>
          <van-image v-else round width="55px" height="55px" :src="require('../../../assets/user.png')"/>
          <h3>{{ topUsername }}</h3>
          <div class="topRight">
            <div class="zuan"></div>
            <p>{{ rank }}</p>
          </div>
        </div>
        <div class="center">
          <van-progress color="#fff" track-color="#3388ff" :percentage="percentageNum" />
          <p>{{ ranks }}</p>
        </div>
        <div class="bottom title">
          <ul>
            <li> <h3>我的卡<span>(张)</span></h3> <p>{{ topForm.cardQuantity ? topForm.cardQuantity : '0' }}</p> </li>
            <li> <h3>余额<span>(元)</span></h3> <p>{{ topForm.balance ? topForm.balance : '0' }}</p> </li>
            <li> <h3>当日分润<span>(元)</span></h3> <p>{{ topForm.todayProfit ? topForm.todayProfit : '0' }}</p> </li>
            <li> <h3>当月分润<span>(元)</span></h3> <p>{{ topForm.thisMonthProfit ? topForm.thisMonthProfit : '0' }}</p> </li>
          </ul>
        </div>
      </div> -->
    </div>
    <van-divider content-position="left">设备信息</van-divider>
    <van-grid class="shebei" :border="false" :column-num="2">
      <van-grid-item to="EquipmentBeyond">
        <div class="header1 leftBtn">
          <div class="sbDiv">
            <p>超流量停机</p>
            <span>{{this.overFlowEqp}}</span>
          </div>
        </div>
      </van-grid-item>
      <van-grid-item to="Equipment/jk">
        <div class="header1 rightBtn">
          <div class="sbDiv ssd">
            <p>机卡分离停机</p>
            <span>{{this.offEqp}}</span>
          </div>
        </div>
      </van-grid-item>
    </van-grid>
    <van-divider content-position="left">快捷功能</van-divider>
    <van-grid :border="false" :column-num="3">
      <div class="box" v-for="(item, index) in list" :key="index">
        <van-grid-item :to="item.push" :text="item.text">
          <template slot="icon">
            <span :class="item.icon"></span>
          </template>
        </van-grid-item>
      </div>
    </van-grid>
    <div class="footer">
      <p>侵权必究 2021</p>
    </div>
  </div>
</template>

<script>
import { mobileIndex, userTopNum, cardGrade } from '@/api/user.js'
export default {
  components: {},
  props: {},
  data () {
    // van-icon van-icon-vip-card-o
    return {
      list: [
        { text: '余额', icon: 'iconfont icon-yue deepBlue', push: 'Balance' },
        // { text: '价格表', icon: 'iconfont icon-jiagebiao- yellow', push: 'PricesList' },
        { text: '订单查看', icon: 'iconfont icon-chaxun greend', push: 'Order' },
        { text: '等级表', icon: 'van-icon van-icon-vip-card-o blue', push: 'Grade' },
        { text: '密码修改', icon: 'van-icon van-icon-bulb-o pinkRed', push: 'ChangePassword' },
        { text: '分享', icon: 'iconfont icon-lianjie greend', push: 'QRcode' },
        { text: '代理商管理', icon: 'iconfont icon-dailishang greend', push: 'AgentManagement' },
        { text: '账户设置', icon: 'iconfont icon-yonghushezhi1 blue samles', push: 'AccountSetup' }
        // { text: '价格修改', icon: 'iconfont icon-xiugai yellow', push: 'RevisePrice' }
      ],
      offEqp: '',
      overFlowEqp: '',
      topUsername: '',
      rank: '',
      ranks: '',
      // 顶部数据
      topForm: {},
      // 等级进度
      percentageNum: 70
    }
  },
  watch: {},
  computed: {},
  methods: {
    // 等级
    async Rank () {
      const { data: res } = await cardGrade({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      this.rank = res.rank
      if (this.rank && this.rank !== 'V7') {
        this.ranks = 'V' + (this.rank.split('')[1] * 1 + 1)
      } else {
        this.percentageNum = 100
        this.ranks = ''
      }
    },
    async getTopNum () {
      const { data: res } = await userTopNum({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      this.topForm = res
    },
    // 超流量数量,已停机数量
    async mobileIndex () {
      // if (this.offEqp === 0 && this.overFlowEqp === 0) return
      // if (this.offEqp !== 'undefined' && this.overFlowEqp !== 'undefined') return
      const { data: res } = await mobileIndex({ token: this.$store.state.token, userId: this.$store.state.userID.split('a')[0] })
      this.$store.commit('setOffEqp', res.offEqp)
      this.$store.commit('setOverFlowEqp', res.overFlowEqp)
      this.offEqp = res.offEqp ? res.offEqp : 0
      this.overFlowEqp = res.overFlowEqp ? res.overFlowEqp : 0
    }
  },
  beforeCreate () {
  },
  created () {
    this.offEqp = this.$store.state.offEqp
    this.overFlowEqp = this.$store.state.overFlowEqp
    // this.topUsername = this.$store.state.accessToken ? this.$store.state.accessToken.nickname : this.$store.state.agentName
    const agentName = this.$store.state.agentName
    this.topUsername = (agentName && agentName !== 'undefined') ? this.$store.state.agentName : this.$store.state.userName
    this.mobileIndex()
    this.getTopNum()
    this.Rank()
  },
  mounted () {}
}
</script>

<style scoped lang='less'>
  .usrBox {
    padding: 25px 25px 0;
    height: 100%;
    padding-bottom: 100px;
    box-sizing: border-box;
    // /deep/.van-share-sheet__options {
    //   align-items: center;
    //   justify-content: center;
    // }
    .header {
      height: 326px;
      width: 100%;
      border-radius: 15px;
      background-color: red;
      background: url(../../../assets/home-banner.png) no-repeat center;
      background-size: 100% 385px;
      overflow: hidden;
      padding-top: 30px;
      color: #fff;
      .info {
        font-size: 36px;
      }
      .degree {
        padding-top: 25px;
        font-size: 30px;
        /deep/.van-progress__pivot {
          display: none;
        }
      }
      .item {
        padding-top: 40px;
        text-align: center;
        font-size: 26px;
      }
      // display: flex;
      // align-items: center;
      // .contentHeader {
      //   width: 100%;
      // }
      // .title {
      //   padding: 15px;
      //   font-size: 30px;
      //   color: #fff;
      // }
      // .top {
      //   display: flex;
      //   // justify-content: space-between;
      //   align-items: center;
      //   .topRight {
      //     display: flex;
      //     align-items: center;
      //     .zuan {
      //       width: 50px;
      //       height: 45px;
      //       background: url(../../../assets/zuan-1.png) no-repeat;
      //       background-size: 100% 100%;
      //     }
      //   }
      // }
      // .center {
      //   display: flex;
      //   align-items: center;
      //   margin: 0 20px!important;
      //   /deep/.van-progress {
      //     flex: 1;
      //     margin: 0 20px!important;
      //     .van-progress__pivot {
      //       display: none;
      //     }
      //   }
      //   p {
      //     color: #fff;
      //     font-size: 35px;
      //   }
      // }
      // .bottom {
      //   ul {
      //     display: flex;
      //     justify-content: space-around;
      //     li {
      //       height: 100px;
      //       display: flex;
      //       flex-direction: column;
      //       justify-content: space-around;
      //       align-items: center;
      //       h3 {
      //         font-size: 28px;
      //         font-weight: 400;
      //         span {
      //           font-size: 25px;
      //         }
      //       }
      //     }
      //   }
      // }
    }
    .box{
      width: 29%;
      height: 185px;
      background-color: #fff;
      margin: 12px 2%;
      box-shadow: 0 4px 10px 5px rgba(15,27,115,8%);
      border-radius: 15px;
      position: relative;
      overflow: hidden;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 8px;
      font-weight: 400;
      .van-grid-item {
        flex: 1;
        padding-right: 0!important;
        height: 80%;
      }
      /deep/.van-grid-item__content {
        display: flex;
        flex-direction: column;
        justify-content: space-around;
        padding: 15px;
      }
    }
    .shebei {
      /deep/.van-grid-item__content {
        padding: 3px 8px;
        .header1 {
          height: 142px;
          width: 100%;
          border-radius: 15px;
          color: #fff;
          .sbDiv {
            display: flex;
            height: 100%;
            flex-direction: column;
            justify-content: space-around;
            align-items: center;
            padding: 24px 0 0;
            p {
              font-size: 32px;
            }
            span{
              font-size: 36px;
            }
          }
        }
        .leftBtn {
          background: url(../../../assets/Stream-1.png) no-repeat center;
          background-size: cover;
        }
        .rightBtn {
          background: url(../../../assets/Stream-2.png) no-repeat center;
          background-size: cover;
        }
      }
    }
    .van-cell-group {
      margin-top: 15px;
      overflow-y: scroll;
      height: 1100px;
      .van-cell:last-child {
        color: #AFAFB8;
        text-align: center;
      }
    }
    /deep/.van-divider {
      margin: 18px 0;
      font-size: 34px!important;
      color: #000;
    }
    .van-divider--content-left::before {
      max-width: 0%;
      margin: 0;
    }
  }
  [class*=van-hairline]::after {
    border: none;
  }
  .greend {
    color: #5dcd96;
  }
  .blue {
    color: #1296db;
  }
  .deepBlue {
    color: #13227a;
  }
  .pinkRed {
    color: #ff9383;
  }
  .yellow {
    color: #ffa347;
  }
  .box span{
    font-size: 68px;
    margin-bottom: 10px;
  }
  .samles {
    font-size: 50px!important;
  }
  .footer {
    width: 100%;
    text-align: center;
    p {
      font-size: 25px;
      color: #bbbbbb;
    }
    margin: 5px 0 15px;
  }
</style>
